import React from 'react';
import { motion } from 'framer-motion';
export type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';
export type BadgeSize = 'sm' | 'md';
interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  size?: BadgeSize;
  icon?: React.ReactNode;
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  size = 'md',
  icon,
  className = ''
}: BadgeProps) {
  const variants = {
    default: 'bg-indigo-100 text-indigo-700 border-indigo-200',
    success: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    warning: 'bg-amber-100 text-amber-700 border-amber-200',
    danger: 'bg-rose-100 text-rose-700 border-rose-200',
    info: 'bg-blue-100 text-blue-700 border-blue-200',
    neutral: 'bg-slate-100 text-slate-600 border-slate-200'
  };
  const sizes = {
    sm: 'px-2 py-0.5 text-[10px]',
    md: 'px-2.5 py-1 text-xs'
  };
  return <span className={`
        inline-flex items-center gap-1.5 rounded-full font-bold uppercase tracking-wider border
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `} data-id="element-1665">
      {icon && <span className="flex-shrink-0" data-id="element-1666">{icon}</span>}
      {children}
    </span>;
}